














// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionContainer from '@/components/charts/ChartEvolutionContainer.vue';
// Import plugins ----------------------------------------------------------------------------------
import i18n from '@/plugins/i18n';
// Import utils ------------------------------------------------------------------------------------
import { useChart, EThemeColor } from '@/utils/charts.utils';
import { EUnitKey } from '@/utils/parameter-units.utils';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionCadence',
  components: {
    ChartEvolutionContainer
  },
  props: {
    manifest: {
      type: Array,
      required: true
    },
    cadence: {
      type: Object
    },
    norms: {
      type: Object
    }
  },
  setup(properties) {
    const {
      evolutionChartStructure,
      getGlobalData,
      getGlobalDataVariations,
      getSerieItemStructure,
      getNormsStructure
    } = useChart();

    const title = 'commons.standards.cadence';

    const cadence: any = computed(() => getGlobalData(properties.cadence));

    const normsType = computed(() => {
      return {
        base: [properties.norms?.min[0], properties.norms?.max[0]]
      };
    });

    const dataVariations = computed(() => getGlobalDataVariations(cadence.value?.global));

    const valid = computed(() => !!cadence.value);

    const series = computed(() => {
      let data = [
        getSerieItemStructure(
          'cadence',
          `${i18n.t('commons.standards.cadence')}`,
          cadence.value?.global,
          EThemeColor.Chart1
        ),
        getSerieItemStructure('cadence', undefined, cadence.value?.ranges, EThemeColor.Chart1, true)
      ];
      // Have norms
      if (properties.norms)
        data.push(getNormsStructure('cadence_norms', properties.norms as { min: number[]; max: number[] }));

      return data;
    });

    const chartOptions = computed(() => {
      return {
        ...evolutionChartStructure(title, properties.manifest, EUnitKey.StepPerMinute, 0),
        series: series.value
      };
    });

    return {
      title,
      dataVariations,
      chartOptions,
      normsType,
      valid
    };
  }
});
